/* eslint-disable @typescript-eslint/naming-convention */
import { random } from 'lodash';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Cookies from 'universal-cookie';
import URL from 'url-parse';

import CrmZone from '@swf/components/CrmZone/CrmZone';
import Translation from '@swf/components/Translation/Translation';
import CloseIcon from '@swf/core/assets/icons/close.svg';
import { CRMZone, ResolverTag } from '@swf/core/enums';
import useResolver from '@swf/core/hooks/useResolver';
import type { Dispatch } from '@swf/core/store';
import { select } from '@swf/core/store';
import CookieNames from '@swf/core/types/Cookies';
import { getPID } from '@swf/core/utils/domains';

import { TXTCLI_Open } from './AppDownloadBanner.messages.json';
import styles from './AppDownloadBanner.scss';

const min = 1e14;
const max = 999e12 - 1;
const cookies = new Cookies();

const AppDownloadBanner: React.FC = () => {
  const {
    notification: { set: setNotification }
  } = useDispatch<Dispatch>();
  const bannerUrl = useResolver(ResolverTag.PRMPSCasinoDownload);
  const visible = useSelector(select.notification.showDownloadBanner);

  const {
    gclid,
    utm_medium: utmMedium,
    utm_source: utmSource
  } = useSelector(select.location.getQuery);

  if (!visible) {
    return null;
  }

  const close = () => setNotification({ name: DOWNLOAD_BANNER, value: false });

  const { DOWNLOAD_BANNER, SIGNAL_ID, AFFILIATE_REF, PROMO, PROMO_IA, MAXYMISER_ID } = CookieNames;
  const promoAms = cookies.get(PROMO);
  const mid = cookies.get(MAXYMISER_ID);
  const promoIa = cookies.get(PROMO_IA);
  const signalId = cookies.get(SIGNAL_ID);

  const pid = getPID(promoAms, promoIa, gclid, utmMedium, utmSource);

  const AffiliateSubscr3 = signalId || random(min, max).toString();
  cookies.set(SIGNAL_ID, AffiliateSubscr3);

  const AffiliateSubscr4 = `ams--${promoAms || 'none'}__mid--${mid || ''}__btag--${promoIa || ''}`;

  const randomNum = random(min, max);
  const afRef = randomNum.toString();
  cookies.set(AFFILIATE_REF, afRef);

  let prmPscasinoDownload;

  if (bannerUrl) {
    prmPscasinoDownload = new URL(bannerUrl);
    prmPscasinoDownload.set('query', {
      ...prmPscasinoDownload.query,
      pid,
      af_sub3: AffiliateSubscr3,
      af_sub4: AffiliateSubscr4,
      af_ref: afRef
    });
  }

  return (
    <div className={styles.container} id="app-download-banner">
      <CloseIcon onClick={close} className={styles.close} />
      <CrmZone zoneId={CRMZone.DOWNLOAD_BANNER} componentType="Single" />
      <a className={styles.resolverLink} href={prmPscasinoDownload?.toString()} onClick={close}>
        <Translation {...TXTCLI_Open} />
      </a>
    </div>
  );
};

export default AppDownloadBanner;
